module.exports = __webpack_public_path__ + "img/grend_2.44d97b2f.jpg";